module.exports = __webpack_public_path__ + "img/lpp-display.ad320333.png";